import { motion } from 'framer-motion'
import { GradientBackground } from './GradientBackground'
import { useProjects } from '../hooks/useProjects'

export function ProjectLavazzaBilanci() {
  const { getRandomProject } = useProjects()
  
  const handleNextProject = () => {
    const randomProject = getRandomProject('lavazza-bilanci')
    if (randomProject) {
      window.location.hash = randomProject.slug
    }
  }

  return (
    <GradientBackground>
      {/* Hero Section - Cover image at 65% height */}
      <section className="relative h-[65vh] w-full">
        <img 
          src="/assets/projects/lavazza_bilanci/cover_sostenibile_circle_3.jpg" 
          alt="Lavazza Bilanci"
          className="w-full h-full object-cover object-center"
        />
      </section>

      {/* Project Info */}
      <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, transparent 0%, #CFCFCF 100%)' }}>
        <div className="container mx-auto max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
          >
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Client</h3>
              <p className="text-lg font-medium text-white">Lavazza</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Services</h3>
              <p className="text-lg font-medium text-white">Graphic Design, Photography</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Year</h3>
              <p className="text-lg font-medium text-white">2017</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Project</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              Visual communication project for Lavazza Bilanci. The work explores two complementary 
              directions: the Civilistico and Sostenibile collections. Each direction captures 
              the essence of Lavazza's commitment to quality and environmental responsibility.
            </p>

            {/* Images Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              <div className="space-y-8">
                <img 
                  src="/assets/projects/lavazza_bilanci/cover_civilistico_circle.jpg" 
                  alt="Lavazza Bilanci Civilistico"
                  className="w-full rounded-lg shadow-lg"
                />
                <img 
                  src="/assets/projects/lavazza_bilanci/doppie_sito.jpg" 
                  alt="Lavazza Bilanci Website"
                  className="w-full rounded-lg shadow-lg"
                />
                <img 
                  src="/assets/projects/lavazza_bilanci/Senza-titolo-4.jpg" 
                  alt="Lavazza Bilanci Design"
                  className="w-full rounded-lg shadow-lg"
                />
                <img 
                  src="/assets/projects/lavazza_bilanci/thumb_gif.gif" 
                  alt="Lavazza Bilanci Animation"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
              <div className="space-y-8">
                <img 
                  src="/assets/projects/lavazza_bilanci/cover_sostenibile_circle_3.jpg" 
                  alt="Lavazza Bilanci Sostenibile"
                  className="w-full rounded-lg shadow-lg"
                />
                <img 
                  src="/assets/projects/lavazza_bilanci/doppie_sito2.jpg" 
                  alt="Lavazza Bilanci Website 2"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Approach</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              The visual approach combines elegance with sustainability, creating a cohesive 
              narrative that speaks to both the tradition and the future of the Lavazza brand.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Navigation Footer */}
      <section className="py-16 px-4 bg-[#CFCFCF]">
        <div className="container mx-auto max-w-4xl">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* Back to Works */}
            <a 
              href="/#works"
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105" style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              <span className="relative z-10 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6"/>
                </svg>
                Back to Works
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </a>

            {/* Next Project */}
            <button 
              onClick={handleNextProject}
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105" style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              <span className="relative z-10 flex items-center gap-2">
                Next Project
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 18 6-6-6-6"/>
                </svg>
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </section>
      
      <style>{`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </GradientBackground>
  )
}
